<template>
  <div class="provider-manage">
    <div class="query-form">
        <div class="search-keyword">
            <a-input placeholder="产品名称、型号、证书编号" v-model="blurry" allowClear style="margin: 0 15px 0 0;width: 500px;" @pressEnter="blurrySearch"></a-input>
            <a-button style="margin: 10px 0" type="primary" icon="search"  @click="blurrySearch">搜索</a-button>
        </div>
        <div class="icon-area">
            <a-icon type="question-circle" style="margin-right: 20px;font-size: 22px;vertical-align: bottom;color: #40a9ff" @click="openInfo"/>
        </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="dataList"
        :pagination="pagination"
        @change="pagChange"
        @expandRowByClick="true"
        :rowKey="record => record.id"
        :loading="tableLoading"
        :scroll="{ x: 1500, y: 500 }">
        <template slot="dept" slot-scope="dept">
        <p v-if="dept">{{dept.name}}</p>
      </template>
       <template slot="dataRange" slot-scope="dataRange">
        <p v-if="dataRange">{{dataRange.name}}</p>
      </template>
      <template slot="product" slot-scope="product">
         <a-popover placement="top">
              <template slot="content">
                  <p style="max-width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="product">{{product}}</p>
              </template>
                  <p class="item-type" v-if="product">{{product}}</p>
            </a-popover>
      </template>
      <template slot="modelSpecification" slot-scope="modelSpecification">
          <a-popover placement="top">
              <template slot="content">
                  <p style="max-width: 500px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="modelSpecification">{{modelSpecification}}</p>
              </template>
                  <p class="item-type" v-if="modelSpecification">{{modelSpecification}}</p>
            </a-popover>
      </template>
        <template slot="keySum" slot-scope="record">
          <a-button type="link" v-if="record.keySum > 0" @click="setKeyPiece(record)">{{record.keySum}}</a-button>
          <p v-else>-</p>
        </template>
        <template slot="state"  slot-scope="state">
            <common-badge :state="state" :text="state"></common-badge>
        </template>

        <template slot="operation"  slot-scope="record">
          <a-button type="link" style="padding:0;" @click="downFiles(record.id, record.number)">下载空检查表</a-button>
        </template>
      </a-table>
    </div>
    <addProvider :isAdd="isAdd" :id="editId" v-if="ifAddProvider" @addSuccess="addSuccess" @hideAction="hideAction"/>
    <info ref="info"/>
    <key-list v-if="isShowDialog" :id="certId" @hideAction="dialogHide"/>
  </div>
</template>
<script>

import { getEntrustList, downloadCheckFiles } from '@/api/consistency'
import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index'

import addProvider from '@/components/consistency/provider/addProvider.vue';
import info from '@/components/consistency/provider/info.vue';
import keyList from '@/components/consistency/provider/keyList.vue';



const align = 'center'
export default {
  name: 'providerManage',
  components: {addProvider, info, keyList},
  data() {
    return {
      formItemLayout:{
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 15
        },
      },
      columns:[
        {
          title: "序号",
          dataIndex: 'No',
          align,
          width: 80
        },
        {
          title: "委托人",
          dataIndex: 'dept',
          scopedSlots: { customRender: 'dept' },
          align,
          width: 200,
          // sorter: true,
        },
        {
          title: "事业部",
          dataIndex: 'dataRange',
          scopedSlots: { customRender: 'dataRange' },
          align,
          sorter: true,
        },
        {
          title: "产品名称",
          dataIndex: 'product',
          scopedSlots: { customRender: 'product' },
          align,
          sorter: true,
          width: 200
        },
        {
          title: "系列型号",
          dataIndex: 'modelSpecification',
          scopedSlots: { customRender: 'modelSpecification' },
          align,
          width: 200,
        },
        {
          title: "关键件数量",
          scopedSlots: { customRender: 'keySum' },
          align,
        },
        {
          title: "证书编号",
          dataIndex: 'number',
          align,
          width: 200,
        },
        {
          title: "状态",
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' },
          sorter: true,
          align,
          width: 100,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          width:120,
          fixed: 'right'
        }
      ],
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '50', '100', '200', '500'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      tableParams: {
        page: '1',
        size: '10'
      },
      roleId: '',
      tableLoading: false,//表格加载动画
      ifAddProvider: false,
      ifShowCertList: false,
      roles: [],
      dataList: [],
      blurry: '',
      sortType: '',
      sortBy: '',
      copyData: '',
      providerId: '',
      companyStr: '',
      isAdd: true,
      editId: '',
      isShowDialog: false,
      certId: '',
      exportStatus: true, // 是否可以下载
    }
  },
  mounted() {
    this.roleId = this.$store.state.user.roles;
    let userId = this.$store.state.user.user.id;
    let userMsg = this.$store.state.user.user;
    this.getlist();
  },
  methods: {
    // 打开说明提示
    openInfo() {
        this.$refs.info.drawervisible = true;
    },
    downFiles(id, number) {
      if (this.exportStatus) {
        this.exportStatus = false;
        downloadCheckFiles(id)
          .then(res => {
              const content = res;
              const blob = new Blob([res], {type: "application/vnd.ms-excel"});
              const fileName = '一致性检查表（'+ number +'）.xls';
              //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
              //IE10以上支持blob但是依然不支持download
              if ('download' in document.createElement('a')) { //支持a标签download的浏览器
                const link = document.createElement('a')//创建a标签
                link.download = fileName//a标签添加属性
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()//执行下载
                URL.revokeObjectURL(link.href) //释放url
                document.body.removeChild(link)//释放标签
              } else { //其他浏览器
                navigator.msSaveBlob(blob, fileName)
              }
              setTimeout(() => {
                this.exportStatus = true;
              }, 1000);
          })
          .catch(error => {
            this.exportStatus = true;
            console.log(error);
          })
      } else {
        this.$message.warning('正在下载中，请勿重复操作！');
      }
    },
    // 搜索
    blurrySearch(){
      this.getlist()
    },
    setKeyPiece(record) {
        this.isShowDialog = true;
        this.certId = record.id;
    },
    dialogHide() {
        this.isShowDialog = false;
    },
    // 翻页
    pagChange(pagination,filters,sorter){
        if (sorter) {
            this.sortBy = sorter.columnKey;
        if (sorter.order == "ascend") {
            this.sortType = 'ASC'
        } else {
            this.sortType = 'DESC'
        }
      } else {
        this.sortBy = '';
        this.sortType = '';
      }
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getlist()
    },
    // 获取列表数据
    getlist(){
      this.tableLoading = true
      this.tableParams.page = this.pagination.current - 1;
      this.tableParams.size = this.pagination.pageSize;
      this.tableParams.sortType = this.sortType;
      this.tableParams.sortBy = this.sortBy;
      this.tableParams.blurry = this.blurry;
      getEntrustList(this.tableParams).then(res=>{
        this.tableLoading = false
        let data = res.content;
        data.map((item,index)=> {
          item.No = index+1
        })
        this.dataList = data
        for(let i=0; i<this.dataList.length; i++) {
          this.dataList[i].No = this.tableParams.page * this.tableParams.size + i + 1
        }
        this.pagination.total = res.totalElements
        this.pagination.current = res.page
        this.pagination.pageSize = res.size
      }).catch(error=>{
        console.log(error)
        this.tableLoading = false
      })
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    stateVal(val) {
        if (val == '0') {
            return '0'
        } else if (val == '2') {
            return '暂停'
        } else if (val == '3') {
            return '已绑定'
        }
    },
  },
}
</script>

<style lang="less" scoped>
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
}
.table {
  background: #fff;
  z-index: 1;
}
.ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}
.query-form {
  padding: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

